import AbstractDexieClass from "../abstractClasses/AbstractDexieErrorLog";

export default class AppStorageError extends AbstractDexieClass {
  constructor() {
    super("AppStorageError", {
      employee: String,
      company: String,
      team: String,
      route: String,
      href: String,
      hint: String,
      errorString: String,
      timeStamp: Date,
    });
  }
}
